const data = {
	"width": 256,
	"height": 256,
	"body": "<path fill=\"currentColor\" d=\"M225.9 114.9a15.8 15.8 0 0 0-13.4-3.1a23.9 23.9 0 0 1-29.3-23.1a16 16 0 0 0-15.9-15.9a23.9 23.9 0 0 1-23.1-29.3A16.1 16.1 0 0 0 128.6 24h-.6A104.1 104.1 0 0 0 24 128.7a104 104 0 0 0 208-1.3a15.7 15.7 0 0 0-6.1-12.5ZM75.5 99.5a12 12 0 1 1 0 17a12 12 0 0 1 0-17Zm25 73a12 12 0 1 1 0-17a12 12 0 0 1 0 17Zm27-40a12 12 0 1 1 17 0a12 12 0 0 1-17 0Zm37 48a12 12 0 1 1 0-17a12 12 0 0 1 0 17Z\"/>"
};
export default data;
